module.exports = __webpack_public_path__ + "static/media/pc_zh.766fccf1.png";